export function GumroadReviewsInfo() {
    
    function render() {
        return /*html*/`
        <img src="/images/No-Import-Feed.svg" alt="No Import Feed" class="mb-4 import-feed-info-image">
        <img src="/images/Import-Feed-Error-image.svg" alt="No Import Feed" class="mb-4 import-feed-error-image hidden">
        <img src="/images/Import-Feed-Success.svg" alt="No Import Feed" class="mb-4 import-feed-success-image hidden">

        <div class="max-w-sm mx-auto platform-info-box">
            <p class="mb-5 text-sm text-gray-500 dark:text-neutral-500 platform-common-info-box">
                Enter Gumroad URL and click on Get Reviews to see fetched reviews from Gumroad here.
            </p>
            <p class="mb-5 text-sm text-gray-500 dark:text-neutral-500 platform-other-info-box hidden"></p>
        </div>
        <div class="max-w-sm mx-auto hidden import-feed-create-wol-page-btn">
            <button class="btn btn-sm btn-outline-primary">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-plus size-4"><path d="M5 12h14"/><path d="M12 5v14"/></svg>
                Create Wall of Love Page
            </button>
        </div>
        `;
    }

    return {
        render,
    };
}